import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Select,
  Textarea,
  VStack,
  useToast,
  Badge,
  Text,
} from '@chakra-ui/react';
import tramitesService, { Tramite } from '../../../../services/tramitesObrasService';

interface ModalCambiarEstatusProps {
  isOpen: boolean;
  onClose: () => void;
  tramite: Tramite;
  onSuccess: () => void;
}

const ESTATUS_OPTIONS = [
  { value: 'REGISTRADO', label: 'Registrado', color: 'blue' },
  { value: 'EN_PROCESO', label: 'En Proceso', color: 'yellow' },
  { value: 'EN_REVISION', label: 'En Revisión', color: 'orange' },
  { value: 'PROCEDENTE', label: 'Procedente', color: 'green' },
  { value: 'NO_PROCEDENTE', label: 'No Procedente', color: 'red' },
  { value: 'CONCLUIDO', label: 'Concluido', color: 'gray' },
];

const ModalCambiarEstatus: React.FC<ModalCambiarEstatusProps> = ({
  isOpen,
  onClose,
  tramite,
  onSuccess,
}) => {
  const [nuevoEstatus, setNuevoEstatus] = useState(tramite.estatus);
  const [comentario, setComentario] = useState('');
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleSubmit = async () => {
    if (nuevoEstatus === tramite.estatus) {
      toast({
        title: 'Error',
        description: 'Debe seleccionar un estatus diferente',
        status: 'error',
        duration: 3000,
      });
      return;
    }

    setLoading(true);
    try {
      await tramitesService.actualizarEstatus(tramite.id, nuevoEstatus, comentario);

      toast({
        title: 'Éxito',
        description: 'Estatus actualizado correctamente',
        status: 'success',
        duration: 3000,
      });

      onSuccess();
    } catch (error: any) {
      toast({
        title: 'Error',
        description: error.response?.data?.error || 'Error al actualizar el estatus',
        status: 'error',
        duration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const estatusActualInfo = ESTATUS_OPTIONS.find((e) => e.value === tramite.estatus);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Cambiar Estatus del Trámite</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Text fontSize="sm">
              <strong>Folio:</strong> {tramite.folio}
            </Text>

            <Text fontSize="sm">
              <strong>Estatus Actual:</strong>{' '}
              <Badge colorScheme={estatusActualInfo?.color || 'gray'}>
                {tramite.estatus}
              </Badge>
            </Text>

            <FormControl isRequired>
              <FormLabel>Nuevo Estatus</FormLabel>
              <Select value={nuevoEstatus} onChange={(e) => setNuevoEstatus(e.target.value)}>
                {ESTATUS_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel>Comentario (Opcional)</FormLabel>
              <Textarea
                value={comentario}
                onChange={(e) => setComentario(e.target.value)}
                placeholder="Ingrese un comentario sobre el cambio de estatus"
                rows={4}
              />
            </FormControl>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancelar
          </Button>
          <Button
            colorScheme="blue"
            onClick={handleSubmit}
            isLoading={loading}
            isDisabled={nuevoEstatus === tramite.estatus}
          >
            Guardar Cambio
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalCambiarEstatus;
